export default "__VITE_ASSET__nQb9_2e3__"